"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertCheckIsExhaustive = void 0;
function assertCheckIsExhaustive(_) {
    throw new Error("Unexpected value. This function should not have been invoked.");
}
exports.assertCheckIsExhaustive = assertCheckIsExhaustive;
